/* 程普（字德謀） */
import { gd } from '../../core/kit.ts';
import { defineHero, hook, S } from '../define.ts';

export default defineHero({
  id: 'chengpu', name: '程普', sub: '字德謀', faction: 'wu', role: '坦克', weapon: 'snake',
  look: { hair: '#e9e5dc', beard: 'long', weaponName: '鐵脊蛇矛', bulk: 1.1, fx: '#ffb24a', c: { metal: '#d9b45c' } },
  skills: [
    ['鐵脊蛇矛', 'multi', '蛇矛三連刺，每段 {55/92/129/166} 傷害；第三刺擊退並暈眩 0.6 秒。', { el: null }],
    ['老臣持重', 'shield', '舉矛防守 2 秒，受到的傷害 -{40/50/60/70}%。', { x: { k: 'brace', dur: 2, dr: [40, 50, 60, 70] }, aim: S(0) }],
    ['三世老臣', 'passive', '600 內每有一名吳將（含自己以外的隊友），護甲 +{2/3/4/5}。', { pv: {}, sig: 'veteran', armor: [2, 3, 4, 5] }],
    ['赤壁先鋒', 'charge', '率火船衝陣，造成 {250/380/510} 傷害並沿途放火。', { pal: 'fire' }],
  ],
  // 專屬技能（技能資料裡的 x.k）
  kinds: {
    // 程普「老臣持重」：減傷
    brace(u, a, X) {
      u.st.dr = Math.max(u.st.dr, X.dur); u.st.drAmt = Math.max(u.st.drAmt || 0, X.dr / 100);
      this.fx({ k: 'spark', x: u.x, y: u.y - 40, col: u.spec.fx });
    },
  },
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 三世老臣：附近每有一名吳將加護甲（每 0.5 秒重算）
    hook('tick', 31, function (u, dt) { const g = u.sg; if (g && g.veteran && (u.oldT = (u.oldT || 0) - dt) <= 0) { u.oldT = 0.5; const n = this.heroes(u.team).filter((h) => h !== u && h.alive && h.spec.faction === 'wu' && gd(u.x, u.y, h.x, h.y) < 600).length; this.addBuff(u, { id: 'veteran', t: 0.8, armor: n * g.veteran.v('armor') }); } }),
  ],
  // 電腦什麼時候放這招
  ai: {
    brace: ({ w, u, t, d, hero, hpR, foeHeroes }) => foeHeroes(350) > 0 && hpR < 0.8,
  },
});
